/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_DoneInputs */

const en_common_done = /** @type {(inputs: Common_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const de_common_done = /** @type {(inputs: Common_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig`)
};

const fr_common_done = /** @type {(inputs: Common_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé`)
};

const es_common_done = /** @type {(inputs: Common_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho`)
};

const it_common_done = /** @type {(inputs: Common_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatto`)
};

const nl_common_done = /** @type {(inputs: Common_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar`)
};

const pl_common_done = /** @type {(inputs: Common_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowe`)
};

const fi_common_done = /** @type {(inputs: Common_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmis`)
};

const da_common_done = /** @type {(inputs: Common_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Færdig`)
};

const sv_common_done = /** @type {(inputs: Common_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klart`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Common_DoneInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_done = /** @type {((inputs?: Common_DoneInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_DoneInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_done(inputs)
	if (locale === "fr") return fr_common_done(inputs)
	if (locale === "es") return es_common_done(inputs)
	if (locale === "it") return it_common_done(inputs)
	if (locale === "nl") return nl_common_done(inputs)
	if (locale === "pl") return pl_common_done(inputs)
	if (locale === "fi") return fi_common_done(inputs)
	if (locale === "da") return da_common_done(inputs)
	if (locale === "sv") return sv_common_done(inputs)
	return en_common_done(inputs)
});